import { acceptUserInvite } from "../../api/userInviteService";

export const useAcceptUserInvite = (successCallback) => {
  const accept = async (data) => {
    try {
      const newRecord = await acceptUserInvite(data);
      successCallback(newRecord);
      return newRecord;
    } catch (error) {
      console.error("Failed to accept user invite:", error);
      throw error;
    }
  };
  return { accept };
};